
export enum RebateTypesEnum {
  ALL_PURCHASES = 1,
  CATEGORY_PURCHASES = 2,
  STOCK_PURCHASES = 3, // AKA Product Purchases
}

